// extracted by mini-css-extract-plugin
export var cardContainer = "_oy-0";
export var cardHeader = "_oy-2";
export var collapsedState = "_oy-3";
export var dragHandle = "_oy-5";
export var dragHandleIcon = "_oy-6";
export var dragging = "_oy-1";
export var titleArea = "_oy-4";